import React, { Suspense } from 'react';
import loadable from '@loadable/component';
import {Router, Route, Switch, Redirect} from 'react-router-dom';
import '../less/index.less';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import theme from '../../theme';
import {ThemeProvider, Preloader} from 'MWC';
import { HelmetProvider } from 'react-helmet-async';
import { CSSTransition } from 'react-transition-group';
import { canUseDOM } from '../../helpers/canUseDOM';
import { ServerUrlContext } from '../../helpers/ServerUrlContext';

const SuspenseCompat = ({children, fallback}) =>
    canUseDOM
        ? <Suspense fallback={fallback}>{children}</Suspense>
        : <React.Fragment>{children}</React.Fragment>;
// const Header = loadable(() => import('../../auxiliary-components/Header'));
const Header = loadable(() => import('../../auxiliary-components/HeaderNew'));
// const Footer = loadable(() => import('../../auxiliary-components/Footer'));
const Footer = loadable(() => import('../../auxiliary-components/FooterNew'));
const Home = loadable(() => import('../../pages/Home'));
const HomeNew = loadable(() => import('../../pages/HomeNew'));
const Cards = loadable(() => import('../../pages/Cards'));
const Business = loadable(() => import('../../pages/Business'));
const Iban = loadable(() => import('../../pages/Business/views/iban.c'));
const Credit = loadable(() => import('../../pages/Credit'));
const Deposit = loadable(() => import('../../pages/Deposit'));
const Payments = loadable(() => import('../../pages/Services/components/Payments'));
const Express = loadable(() => import('../../pages/Express'));
const Career = loadable(() => import('../../pages/Career'));
const Branches = loadable(() => import('../../pages/Branches'));
const MapPage = loadable(() => import('../../pages/MapPage'));
const Contacts = loadable(() => import('../../pages/Contacts'));
const Terms = loadable(() => import('../../pages/Terms'));
const Tso = loadable(() => import('../../pages/TSO'));
const Fgvo = loadable(() => import('../../pages/Fgvo'));
const Security = loadable(() => import('../../pages/Security'));
const Safety = loadable(() => import('../../pages/Safety'));
const Search = loadable(() => import('../../pages/Search'));
const Services = loadable(() => import('../../pages/Services'));
const Archive = loadable(() => import('../../pages/Archive'));
const NotFound = loadable(() => import('../../pages/NotFound'));
const DynamicInfo = loadable(() => import('../../pages/DynamicInfo'));
const CreditProtection = loadable(() => import('../../pages/CreditProtection'));
const AntiRus = loadable(() => import('../../pages/AntiRus'));
const AtbMarket = loadable(() => import('../../pages/AtbMarket'));
const CloseA24Web = loadable(() => import('../../pages/CloseA24web'));
const ForPartners = loadable(() => import('../../pages/ForPartners'));
const ThankYouPage = loadable(() => import('../../pages/ThankyouPage'));
import NotificationModal from '../../auxiliary-components/NotificationModal';
/** todo remove after create news **/
const News = loadable(() => import('../../pages/News'));
// import News from '../../pages/NewsOld';
const Red = loadable(() => import('../../pages/Redirect'));
const GreenCard = loadable(() => import('../../pages/GreenCard'));
const FaceId = loadable(() => import('../../pages/FaceId'));
const SpecialOffers = loadable(() => import('../../pages/SpecialOffers'));
const Leasing = loadable(() => import('../../pages/Services/components/Leasing'));
const MobStoreLink = loadable(() => import('../../auxiliary-components/MobStoreLink'));
const ScrollFAQ = loadable(() => import('../../auxiliary-components/shared/ScrollFAQ'));
const Gadgetomania = loadable(() => import('../../pages/Gadgetomania'));
const Ltd = loadable(() => import('../../pages/Ltd'));
const PayInInstallment = loadable(() => import('../../pages/PayInInstallments'));
// import TransferByPhone from '../../TransferByPhone';
const AppleSummer = loadable(() => import('../../pages/AppleSummer'));
const AlwaysTouchOffers = loadable(() => import('../../pages/SpecialOffers/AlwaysTouchOffers'));
const ContactLess = loadable(() => import('../../pages/SpecialOffers/ContactLess'));
const MobileMenuQr = loadable(() => import('../../pages/MobileMenuQr'));
const ShareLink = loadable(() => import('../../auxiliary-components/shared/ShareLink'));
const DownloadsPage = loadable(() => import('../../pages/DownloadsPage'));
const BusinessCard = loadable(() => import('../../pages/BusinessCard'));
const SafeFiles = loadable(() => import('../../pages/SafeFiles'));
const WeWorkModal = loadable(() => import('../../auxiliary-components/WeWorkModal'));
const ScrollButton = loadable(() => import('../../auxiliary-components/shared/ScrollButton'));
const MasterCardSpecialOffer = loadable(() => import('../../pages/MasterCardSpecialOffer/views/masterCardSpecialOffer.c'));
const Policy = loadable(() => import('../../pages/Policy'));
const AboutNewGeneral = loadable(() => import('../../pages/About/components/general'));
const DigitalPromoMC = loadable(() => import('../../pages/SpecialOffers/DigitalPromoMC'));
const GoodDeedsMC = loadable(() => import('../../pages/SpecialOffers/GoodDeedsMC'));
const OkkoPromoMC = loadable(() => import('../../pages/SpecialOffers/OkkoPromoMC'));
const UnbrokenOffer = loadable(() => import('../../pages/SpecialOffers/UnbrokenOffer'));
const ATBPromo = loadable(() => import('../../pages/SpecialOffers/AtbPromo'));
const MillionAtb = loadable(() => import('../../pages/SpecialOffers/MillionAtb'));
const VisaIphone = loadable(() => import('../../pages/SpecialOffers/VisaIPhone'));
const StepToVictory = loadable(() => import('../../pages/SpecialOffers/StepToVictory'));
const AssembledUa = loadable(() => import('../../pages/SpecialOffers/AssembledUa'));
const PayoneerIphone = loadable(() => import('../../pages/SpecialOffers/PayoneerIphone'));
const SorryPage = loadable(() => import('../../pages/SorryPage'));
const AuroraPromo = loadable(() => import('../../pages/SpecialOffers/AuroraPromo'));
const HalfMillionDraw = loadable(() => import('../../pages/SpecialOffers/HalfMillionDraw'));
const ShopingAtb = loadable(() => import('../../pages/SpecialOffers/ShopingAtb'));
const KidsDrawModule = loadable(() => import('../../pages/SpecialOffers/KidsDraw'));
const EnergyIndependence = loadable(() => import('../../pages/SpecialOffers/EnergyIndependence'));
const ExpressEnergy = loadable(() => import('../../pages/SpecialOffers/ExpressEnergy'));
const ExpressPartner = loadable(() => import('../../pages/ExpressPartner'));
const SepaFop = loadable(() => import('../../pages/SpecialOffers/SepaFop'));
const EnergyCredit = loadable(() => import('../../pages/Business/components/EnergyCredit'));
const InsuranceTour = loadable(() => import('../../pages/InsuranceTour'));
const Referal = loadable(() => import('../../pages/Referal'));
const CrsFatca = loadable(() => import('../../pages/CrsFatca'));
const DownloadApp = loadable(() => import('./../../auxiliary-components/DownloadApp'));
const PRpage = loadable(() => import('../../pages/PRpage'));
const AtbSpecialOffer = loadable(() => import('../../pages/AtbSpecialOffer'));
const KidsCardOffer = loadable(() => import('./../../pages/KidsCardOffer'));
const KidsCardOffer2 = loadable(() => import('./../../pages/KidsCardOffer2'));
const TouchWinOffer = loadable(() => import('./../../pages/TouchWinOffer'));
const NewCardGame = loadable(() => import('./../../pages/NewCardGame'));
const ESimActivation = loadable(() => import('./../../pages/ESimActivation'));
const BusinessAll = loadable(() => import('../../pages/BusinessAll'));
const OpenBanking = loadable(() => import('../../pages/OpenBanking'));
const DownloadAppBottom = loadable(() => import('../../auxiliary-components/DownloadAppBottom'));
const BrightStartPromo = loadable(() => import('./../../pages/BrightStartPromo'));
const FundraisingDrone = loadable(() => import('../../pages/FundraisingDrone'));
const PublicContracts = loadable(() => import('../../pages/PublicContracts'));

import ScrollToTop from "../ScrollToTop";
import { HEADER_HOVER_TIMEOUT } from '../../auxiliary-components/HeaderNew/constants';

export default function template() {
    const { lang, single, withoutHeader } = this.state,
      { viewport } = this.props,
      header = (!single && !withoutHeader) ?
        <Header lang={lang} viewport={viewport} isHomePage={this.state.isHomePage} showDownloadApp={this.state.showDownloadApp} isCollapsed={this.state.isCollapsed} history={this.history} userType={this.state.userType} changeUserType={this.changeUserType}/> : "",
      footer = !single ? <Footer lang={lang} viewport={viewport} /> : "",
      hideDownloadAppBottomUrls = [
          "/about/general",
          "/about/strategy",
          "/about/top",
          "/about/reports",
          "/about/for-stakeholders",
          "/about/special-info",
          "/about/owners",
          "/about/partner",
          "/about/esg"
      ],
      currentPathname = canUseDOM ? this.history.location.pathname : null,
      downloadAppBottom = (
          <ServerUrlContext.Consumer>
              {serverUrl => {
                  const pathname = (currentPathname || serverUrl || '').split('?')[0];
                  const shouldShow = !single && !hideDownloadAppBottomUrls.includes(pathname);
                  return shouldShow ? <DownloadAppBottom/> : null;
              }}
          </ServerUrlContext.Consumer>
      ),
      prPagePaths = [
          "/instagram/robotaabank/:type?",
          "/instagram/abank_official/:type?",
          "/facebook/abank_official/:type?",
          "/facebook/robotaabank/:type?",
          "/youtube/abank_official/:type?",
          "/tiktok/abank_official/:type?"
      ];

    const routeContent = (
                <SuspenseCompat fallback={<div style={{ marginTop: 50 }} className="module-app-content"><Preloader/></div>}>
                    <ScrollToTop />
                    {canUseDOM && this.state.isHomePage && this.state.isSmallScreen &&
                      <CSSTransition
                        in={this.state.showDownloadApp}
                        timeout={HEADER_HOVER_TIMEOUT}
                        classNames="fly-download-app"
                        unmountOnExit
                      >
                        <DownloadApp />
                      </CSSTransition>
                    }
                    {header}
                    <section className={`module-app-content ${this.state.isBlackTheme ? 'black' : ''}`}>
                        {!single ? <ScrollFAQ isApple={this.state.isApple} /> : ''}
                        <Switch>
                            {/* <Route
                                exact
                                path='/'
                                render={(props) => (
                                    <Home {...props} lang={lang} viewport={viewport} />
                                )}
                            /> */}
                            <Route
                                exact
                                path='/'
                                render={(props) => (
                                    <HomeNew {...props} lang={lang} viewport={viewport} onToggleDownloadApp={this.setDownloadAppVisibility}/>
                                )}
                            />

                            <Route
                                exact
                                path='/business_all'
                                render={(props) => (
                                    <BusinessAll {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            {/* <Route
                                path='/offrus'
                                render={(props) => (
                                    <AntiRus {...props} lang={lang} viewport={viewport} />
                                )}
                            /> */}

                            <Route
                                path='/a24web-close'
                                render={(props) => (
                                    <CloseA24Web {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                                path='/touch_win_offer'
                                render={(props) => (
                                    <TouchWinOffer {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                                path='/kids_card_offer'
                                render={(props) => (
                                    <KidsCardOffer {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                                path='/kids_card_offer2'
                                render={(props) => (
                                    <KidsCardOffer2 {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                                path='/newcardgame'
                                render={(props) => (
                                    <NewCardGame {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                                path='/bright_start_promo'
                                render={(props) => (
                                    <BrightStartPromo {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                              path='/forpartners'
                              render={(props) => (
                                <ForPartners {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              path='/fundraising_drone'
                              render={(props) => (
                                <FundraisingDrone {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                                path='/atb-market'
                                render={(props) => (
                                    <AtbMarket {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                              path='/atb-market1'
                              render={(props) => (
                                <AtbMarket {...props} simplePage={true} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                                path='/e-sim-activation'
                                render={(props) => (
                                    <ESimActivation {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                                path='/openbanking/:type?'
                                render={(props) => (
                                    <OpenBanking {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                                exact
                                path='/thankyou/a24'
                                render={(props) => (
                                    <ThankYouPage {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/cards/:type?/:action?'
                                render={(props) => (
                                    <Cards {...props} lang={lang} viewport={viewport} setBlackTheme={this.setBlackTheme}         setForcedTheme={this.setForcedTheme} clearForcedTheme={this.clearForcedTheme} />
                                )}
                            />
                            <Route
                                path='/business/iban'
                                render={(props) => (
                                    <Iban {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/business/:type?/:action?'
                                render={(props) => (
                                    <Business {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/https://ab.a-bank.com.ua/'
                                render={(props) => (
                                    <meta httpEquiv="Refresh" content="0;URL=https://ab.a-bank.com.ua/"/>
                                )}
                            />
                            <Route
                                path='/credit/:type?'
                                render={(props) => (
                                    <Credit {...props} lang={lang} viewport={viewport} theme={this.state.theme}/>
                                )}
                            />
                            <Route
                                path='/deposits'
                                render={(props) => (
                                    <Deposit {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/about/:category'
                                render={(props) => (
                                  <AboutNewGeneral {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/payments'
                                render={(props) => (
                                    <Payments {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/a-express'
                                render={(props) => <Redirect to='/business/a-express' />}
                            />
                            <Route
                                path='/express'
                                render={(props) => (
                                    <Express {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/career/:type?/:id?'
                                render={(props) => (
                                    <Career {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/contacts'
                                render={(props) => (
                                    <Contacts isApple={this.state.isApple} {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/terms/:type?/:id?'
                                render={(props) => (
                                    <Terms {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                              path='/self_service_terminal'
                              render={(props) => (
                                <Tso {...props} lang={lang} viewport={viewport} />
                              )}
                            />
                            <Route
                                path='/fgvo'
                                render={(props) => (
                                    <Fgvo {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/branches'
                                render={(props) => (
                                    <MapPage {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/transfers'
                                render={() => <Redirect to='/' />}
                            />
                            <Route
                                path='/security'
                                render={(props) => (
                                    <Security {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                              path='/search'
                              render={(props) => (
                                <Search {...props} lang={lang} viewport={viewport} />
                              )}
                            />
                            <Route
                                path='/safety'
                                render={(props) => (
                                    <Safety {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/services/:type?/:secondType?/:lastPage?'
                                render={(props) => (
                                    <Services {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/archive'
                                render={(props) => (
                                    <Archive {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/special_offers/:type?'
                                render={(props) => (
                                    <SpecialOffers {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/mobile-menu-qr/:type?'
                                render={(props) => (
                                    <MobileMenuQr {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/news/:id?'
                                render={(props) => (
                                    <News {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/message/141118'
                                render={(props) => (
                                    <DynamicInfo {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/r'
                                render={(props) => (
                                    <Red {...props} lang={lang} viewport={viewport} viber />
                                )}
                            />
                            <Route
                                path='/t/:action?'
                                render={(props) => (
                                    <Red {...props} lang={lang} viewport={viewport} referral />
                                )}
                            />
                            <Route
                                path='/green/:section?'
                                render={(props) => (
                                    <GreenCard {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/faceid/:type'
                                render={(props) => (
                                    <FaceId {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                path='/auto-leasing'
                                render={(props) => (
                                    <Leasing {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/gadgetomania'
                                render={(props) => (
                                    <Gadgetomania {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/DE'
                                render={(props) => (
                                    <Ltd {...props} lang={lang} viewport={viewport} ltd={'DE'} />
                                )}
                            />
                            <Route
                                exact
                                path='/PR'
                                render={(props) => (
                                    <Ltd {...props} lang={lang} viewport={viewport} ltd={'PR'} />
                                )}
                            />
                            <Route
                                exact
                                path='/DF'
                                render={(props) => (
                                    <Ltd {...props} lang={lang} viewport={viewport} ltd={'DF'} />
                                )}
                            />
                            <Route
                                exact
                                path='/KE'
                                render={(props) => (
                                    <Ltd {...props} lang={lang} viewport={viewport} ltd={'KE'} />
                                )}
                            />
                            <Route
                                exact
                                path='/AK'
                                render={(props) => (
                                    <Ltd {...props} lang={lang} viewport={viewport} ltd={'AK'} />
                                )}
                            />
                            <Route
                                exact
                                path='/pay-in-installment'
                                render={(props) => (
                                    <PayInInstallment {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            {/* <Route
                                exact
                                path="/transfers/phone"
                                render={props => (
                                    <TransferByPhone {...props} lang={lang} viewport={viewport} />
                                )}
                            /> */}
                            <Route
                                exact
                                path='/apple-summer'
                                render={(props) => (
                                    <AppleSummer {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/always-touch'
                                render={(props) => (
                                    <AlwaysTouchOffers {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/contact-less'
                                render={(props) => (
                                    <ContactLess {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/mobile-menu-qr'
                                render={(props) => (
                                    <MobileMenuQr {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/business-card/:section?'
                                render={(props) => (
                                    <BusinessCard {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                                exact
                                path='/downloads-page'
                                render={(props) => (
                                    <DownloadsPage {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/sharelink'
                                render={(props) => (
                                    <ShareLink {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/safe-files/:type?'
                                render={(props) => (
                                    <SafeFiles {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/credit-protection'
                                render={(props) => (
                                    <CreditProtection {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/policy'
                                render={(props) => (
                                    <Policy {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                                exact
                                path='/insurance_tour'
                                render={(props) => (
                                    <InsuranceTour {...props} lang={lang} viewport={viewport} />
                                )}
                            />

                            <Route
                              exact
                              path='/sorry-page'
                              render={(props) => (
                                <SorryPage {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/digitalpromomc'
                              render={(props) => (
                                <DigitalPromoMC {...props} lang={lang} viewport={viewport} />
                              )}
                            />
                            <Route
                              exact
                              path='/offerpayoneer'
                              render={(props) => (
                                <PayoneerIphone {...props} lang={lang} viewport={viewport} />
                              )}
                            />
                            <Route
                                exact
                                path='/communication-without-borders'
                                render={(props) => (
                                    <MasterCardSpecialOffer {...props} lang={lang} viewport={viewport} />
                                )}
                            />
                            <Route
                              exact
                              path='/good-deeds-MC'
                              render={(props) => (
                                <GoodDeedsMC {...props} lang={lang} viewport={viewport} />
                              )}
                            />
                            <Route
                              exact
                              path='/millionatb'
                              render={(props) => (
                                <MillionAtb {...props} lang={lang} viewport={viewport} />
                              )}
                            />
                            <Route
                              exact
                              path='/visaiphone'
                              render={(props) => (
                                <VisaIphone {...props} lang={lang} viewport={viewport} />
                              )}
                            />
                            <Route
                              exact
                              path='/step_to_victory'
                              render={(props) => (
                                <StepToVictory {...props} lang={lang} viewport={viewport} />
                              )}
                            />
                            <Route
                              exact
                              path='/assembled_ua'
                              render={(props) => (
                                <AssembledUa {...props} lang={lang} viewport={viewport} />
                              )}
                            />
                            <Route
                              exact
                              path='/unbroken-donation'
                              render={(props) => (
                                <UnbrokenOffer {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/atb-promo'
                              render={(props) => (
                                <ATBPromo {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/public_contracts'
                              render={(props) => (
                                <PublicContracts {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/avrorapromo'
                              render={(props) => (
                                <AuroraPromo {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/500000_draw'
                              render={(props) => (
                                <HalfMillionDraw {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/shopping_gifts_atb'
                              render={(props) => (
                                <ShopingAtb {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/kids_draw'
                              render={(props) => (
                                <KidsDrawModule {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/back_to_school'
                              render={(props) => (
                                <KidsDrawModule secondOffer {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/energy_independence'
                              render={(props) => (
                                <EnergyIndependence {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/express_energy'
                              render={(props) => (
                                <ExpressEnergy {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/express_partner'
                              render={(props) => (
                                <ExpressPartner {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/sepa_fop'
                              render={(props) => (
                                <SepaFop {...props} lang={lang} viewport={viewport} />
                              )}
                            />


                            <Route
                              exact
                              path='/promomcokko'
                              render={(props) => (
                                <OkkoPromoMC {...props} year={'2023'} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/promomcokko2024'
                              render={(props) => (
                                <OkkoPromoMC {...props} year={'2024'} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/promomcokko24'
                              render={(props) => (
                                <OkkoPromoMC {...props} year={'2024_2'} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/energy_credit'
                              render={(props) => (
                                <EnergyCredit {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/atb_specialoffer_:type'
                              render={(props) => (
                                <AtbSpecialOffer {...props} lang={lang} viewport={viewport} />
                              )}
                            />


                            <Route
                              exact
                              path='/referal'
                              render={(props) => (
                                <Referal {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            <Route
                              exact
                              path='/crs-fatca'
                              render={(props) => (
                                <CrsFatca {...props} lang={lang} viewport={viewport} />
                              )}
                            />

                            {prPagePaths.map((path) => (
                              <Route
                                exact
                                path={path}
                                render={(props) => (
                                  <PRpage {...props} lang={lang} page={path.replace(/:type\?$/, '')} viewport={viewport} />
                                )}
                              />
                            ))
                            }

                            <Route
                                render={(props) => (
                                    <NotFound {...props} lang={lang} viewport={viewport} />
                                )}
                            />


                        </Switch>
                        {downloadAppBottom}
                    </section>
                    {footer}
                </SuspenseCompat>
    );

    // On server, StaticRouter and HelmetProvider are provided by entry-server.js
    if (!canUseDOM) {
        return (
            <ThemeProvider theme={theme}>
                {routeContent}
            </ThemeProvider>
        );
    }

    return (
      <HelmetProvider>
        <ThemeProvider theme={theme}>
            <Router history={this.history}>
                {routeContent}
            </Router>
        </ThemeProvider>
      </HelmetProvider>
    );
}
